import React from "react";
import "./WorkOut.css";
import Whatsapp from "../Components/Whatsapp";
import FaqWidget from "./FaqWidget";
import Navbar from "../Components/Navbar";
import MainImg from "../Images/Clasess.webp";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { Link } from "react-router-dom";

import Headroom from "react-headroom";
const WorkOut = () => {
  useEffect(() => {
    document.title = "Corefit Plus Pilates Studio | Pilates Class types ";
  }, []);

  const handle = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Workout types of Pilates | Corefit Plus Pilates Studio </title>
        <meta
          name="description"
          content="See the Perfect Pilates Exercise for Your Fitness Goals at CorefitPlus. Find the Perfect Class to Enhance Your Strength, Flexibility, and Well-Being. Join Us Today!"
        />
      </Helmet>

      <Whatsapp />
      <FaqWidget />

      <div className="Hero1">
        <img src={MainImg} alt="xxx" className="hero-image" />
        <Headroom>
          <div className="sticky-navbar">
            <Navbar />
          </div>
        </Headroom>
      </div>
      <div className="overlayxy">
        <div className="contentt-container">
          <p>
            {" "}
            <span className="writte1">Classes</span>{" "}
          </p>
        </div>
      </div>
      <div>
        <div className="toggle">
          <span>
            <Link className="link-pilates" onClick={() => handle("pilates")}>
              Pilates
            </Link>
          </span>{" "}
          /{" "}
          <span>
            <Link className="link-pilates" onClick={() => handle("yoga")}>
              Yoga
            </Link>
          </span>
        </div>
        <hr className="mnbv" />

        <section id="pilates">
          <div className="wo">
            <div className="Wo1">
              <div className="wo22">
                <p>PILATES</p>
                <hr className="mnbv" />
              </div>
              <div className="wo33">
                <p>
                  <div>CLASSES FOR EVERYBODY</div>
                  Explore our range of Pilates class types designed to cater to
                  your unique needs and preferences. Whether you're a beginner
                  looking to build a strong foundation or an advanced
                  practitioner seeking a challenging workout, we have the ideal
                  classes for you.
                  <p style={{ fontSize: "18px" }}>
                    We offer Group Sessions, Private Sessions, Private
                    Duo at our Studios.
                  </p>
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>BEGINNER CLASSICAL</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Mat & Reformer
                  <br />
                  <div className="wo0">
                    <p>
                      A foundational class focused on core strength,
                      flexibility and alignment using traditional Pilates
                      exercises on both Mat and Reformer.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: Beginner
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>INTERMEDIATE/ADVANCED</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Mat & Reformer
                  <br />
                  <div className="wo0">
                    <p>
                      A dynamic, challenging class following classical
                      sequences with stronger core work, fluid transitions
                      and a more advanced repertoire.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: Experienced
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>SIGNATURE CONTEMPORARY</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Reformer
                  <br />
                  <div className="wo0">
                    <p>
                      Our signature full-body Reformer workout building
                      strength, stamina and balance through controlled
                      movement. Challenging yet low-impact.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>CHAIR & TOWER</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Chair & Tower
                  <br />
                  <div className="wo0">
                    <p>
                      A full-body workout on the Pilates Chair and Tower
                      building strength, balance and control through
                      precision, stability and resistance training.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>UPPER BODY BLAST</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Props & Reformer
                  <br />
                  <div className="wo0">
                    <p>
                      A creative session using BOSU, Magic Circle and
                      TheraBand to challenge balance, core control and
                      coordination through varied movement.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>POWER PROPS — TRX</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Reformer & TRX
                  <br />
                  <div className="wo0">
                    <p>
                      A creative session using TRX suspension to build
                      strength, stability and coordination, adding variety
                      and intensity to your practice.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: Experienced
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>POWER PROPS — BOSU</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  BOSU & Props
                  <br />
                  <div className="wo0">
                    <p>
                      A creative session using BOSU to build
                      strength, stability and coordination, adding variety
                      and intensity to your practice.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: Experienced
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>JUMPBOARD</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Reformer & Jumpboard
                  <br />
                  <div className="wo0">
                    <p>
                      A high-energy, cardio-infused class blending
                      Jumpboard, rowing intervals and dynamic movement to
                      boost endurance, core stability and strength.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: Intermediate
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>CARDIO PLEASE!</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Reformer & Jumpboard
                  <br />
                  <div className="wo0">
                    <p>
                      A fast-paced cardio-led Pilates session designed to
                      raise the heart rate, build stamina and keep you
                      moving throughout.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: Intermediate
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>STRETCH FLOW</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Reformer
                  <br />
                  <div className="wo0">
                    <p>
                      A gentle yet effective class releasing tension and
                      improving flexibility through controlled movement,
                      deep stretches and increased range of motion.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo22">
                <p>SPECIALITY CLASSES</p>
                <hr className="mnbv" />
              </div>
              <div className="wo33">
                <p>Available at selected studios</p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>BURN LAB</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Mat
                  <br />
                  <div className="wo0">
                    <p>
                      High-energy functional strength training designed to build
                      endurance, power and full-body stamina through dynamic,
                      athletic movement.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                  <br />
                  Available at: GK2 • NFC • Noida
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>ROLL & RELEASE</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Mat & Foam Roller
                  <br />
                  <div className="wo0">
                    <p>
                      A recovery-focused session combining Mat Pilates and foam
                      roller work to improve mobility, release tension and support
                      muscle recovery.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                  <br />
                  Available at: GK2 • NFC • Noida
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>MOTR</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  MOTR & Mat
                  <br />
                  <div className="wo0">
                    <p>
                      A dynamic Pilates-based workout on the MOTR blending
                      strength, cardio, balance and functional movement in one
                      flowing session.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                  <br />
                  Available at: GK2 • NFC • Noida
                </p>
              </div>
            </div>
            <div className="Wo1">
              <div className="wo2">
                <p>RED HOT PILATES</p>
                <hr />
              </div>
              <div className="wo3">
                <p>
                  Mat
                  <br />
                  <div className="wo0">
                    <p>
                      Pilates performed under red light therapy, pairing controlled
                      movement with light exposure for recovery.
                    </p>{" "}
                  </div>
                  <br />
                  Intensity: All levels
                  <br />
                  Available at: GK2 • NFC • Noida
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="yoga">
          <div className="we">
            <div className="part2">
              <div className="Wo1">
                <div className="uo22">
                  <p>Yoga</p>
                  <hr className="mnbv" />
                </div>
                <div className="wo33">
                  <p>A Better Life For All</p>
                  <p className="wo0">
                    This 21st century Yoga is built on western scientific
                    foundations combined with the wisdom of Ayurveda. In every
                    single session, experience better health and satisfaction as
                    you enjoy the benefits of a youthful, well-toned body to be
                    able to live life to your fullest.
                  </p>
                  <p style={{ fontSize: "19px" }}>
                    Yoga classes are available only at Noida Studio.
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>SUN VINYASA (SOLAR FLOW)</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    ENERGY & BALANCE
                    <br />
                    <div className="wo0">
                      <p>
                        Awakening and balancing your solar power, this Solar series is a great way to be fit and healthy and is suitable for athletes, students, working professionals, and seniors alike! This class benefits all systems of the body i.e. cardiovascular, muscular, skeletal and nervous systems.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: OPEN TO ALL LEVELS
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>YOGA CORE</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    CORE STRENGTH
                    <br />
                    <div className="wo0">
                      <p>
                        These postures help reduce back pain, strengthen the core muscles that support the back, hips, and stomach. Having strong abdominal muscles and back muscles is the key to prevent back pain. Strong core helps advancing and deepening in various yoga postures and other spiritual practices.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: OPEN TO ALL LEVELS
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>CARDIO YOGA</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    ASANA BASED CARDIO
                    <br />
                    <div className="wo0">
                      <p>
                        Stop running or cycling and try our cardio yoga that delivers maximum benefits from burning fat for 24 to 48 hrs after you complete your exercise along with toning and firming your body that you usually can't get from running. There is no better exercise that incorporates complete body training that works your core, upper body and lower body strength as well as legs alone. Strengthen your heart, burn fats and boost metabolism in this amazing class.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: INTERMEDIATE LEVEL
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>ASANA & PRANA</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    REJUVENATE
                    <br />
                    <div className="wo0">
                      <p>
                        Use of specific postures and breathing techniques to help relieve stress and tension instantly. This class helps the body, increase blood circulation, improve the endocrine system and correct body metabolism along with physiological functions.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: OPEN TO ALL LEVELS
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>YOGA SHAKTI</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    POWER FLOW*
                    <br />
                    <div className="wo0">
                      <p>
                        This class covers all aspects of classical Yoga practice in a systematic way. Specific Pranayama (breathing), Asana (postures), Dharana (concentration), Bandha (locks) and Nidra (blissful sleep) awaken dormant powers. This systematic approach will give you the foundation to reach greater heights as you achieve better health both physically and mentally.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: INTERMEDIATE LEVEL
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>ANTI-AGING YOGA</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    REVERSE AGING
                    <br />
                    <div className="wo0">
                      <p>
                        This class raises your body temperature, compresses and decompresses the body tissues to eliminate the toxins. The poses help with lymphatic drainage, constipation relief and removal of energy blocks. All the stretching, twisting and inversions will help revitalize and reverse aging.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: OPEN TO ALL LEVELS
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>RESET YOGA</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                    RELEASE & RESTORE
                    <br />
                    <div className="wo0">
                      <p>
                        A calming practice designed to release physical tension, quiet the mind and restore the body. Gentle stretches, mindful movements and focused breathing help improve flexibility, reduce stress and promote relaxation. This class is ideal for resetting your body and mind, leaving you feeling refreshed, balanced and renewed.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: OPEN TO ALL LEVELS
                  </p>
                </div>
              </div>
              <div className="Wo1">
                <div className="uo2">
                  <p>RED FLOW YOGA</p>
                  <hr />
                </div>
                <div className="wo3">
                  <p>
                   STRENGTH & FLOW
                    <br />
                    <div className="wo0">
                      <p>
                        A dynamic and energising yoga practice that combines flowing sequences with strength-building postures. Designed to improve mobility, balance, endurance and body control, this class keeps the body active while encouraging focused breathing and mindful movement. A powerful flow to build strength, release tension and energise the body.
                      </p>{" "}
                    </div>
                    <br />
                    Intensity: INTERMEDIATE LEVEL
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WorkOut;
